// extracted by mini-css-extract-plugin
export default {"workSection":"Portfolio_workSection__-AIeZ"};